module.exports = __webpack_public_path__ + "static/media/lepes2.9935de33.png";